module.exports = __webpack_public_path__ + "img/design2.aa09a0f4.png";